var render = function render(){var _vm=this,_c=_vm._self._c;return _c('import-component',{attrs:{"model_name":"article","props_to_send":_vm.props_to_send,"file_name":"articulos-base","advises":_vm.advises,"columns":_vm.columns,"actions":_vm.actions}},[_c('select-provider',{attrs:{"props_to_send":_vm.props_to_send}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }